import { render, staticRenderFns } from "./bhpTitle.vue?vue&type=template&id=90857740&scoped=true&"
import script from "./bhpTitle.vue?vue&type=script&lang=js&"
export * from "./bhpTitle.vue?vue&type=script&lang=js&"
import style0 from "./bhpTitle.vue?vue&type=style&index=0&id=90857740&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90857740",
  null
  
)

component.options.__file = "bhpTitle.vue"
export default component.exports